<div class="base-component component-white">
  <h5 class="title text-hard-blue">Detalhes</h5>
  <br>
  <div fxLayout.lt-md="column" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start space-between">
    <div fxFlex="50">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Selecionar Tipo do Chamado</mat-label>
        <mat-select [disabled]="_loading" [(ngModel)]="type" (selectionChange)="detailsChanged()">
          <mat-option value="I">Incidente</mat-option>
          <mat-option value="D">Defeito</mat-option>
          <mat-option value="P">Problema</mat-option>
          <mat-option value="A">Requisição de Alteração</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxFlex="50">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Selecionar Prioridade</mat-label>
        <mat-select [disabled]="_loading" [(ngModel)]="priority" (selectionChange)="detailsChanged()">
          <mat-option value="B">Baixa</mat-option>
          <mat-option value="M">Média</mat-option>
          <mat-option value="A">Alta</mat-option>
          <mat-option value="U">Urgente</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout.lt-md="column" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start space-between">
    <div fxFlex="50">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Selecionar Status</mat-label>
        <mat-select [disabled]="_loading" [(ngModel)]="status" (selectionChange)="detailsChanged()">
          <mat-option value="A">Aberto</mat-option>
          <mat-option value="T">Em atendimento</mat-option>
          <mat-option value="P">Pendente</mat-option>
          <mat-option value="R">Resolvido</mat-option>
          <mat-option value="F">Fechado</mat-option>
          <mat-option value="C">Cancelado</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxFlex="50">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Selecionar Operador</mat-label>
        <mat-select [disabled]="_loading" [(ngModel)]="operator" (selectionChange)="detailsChanged()">
          <mat-option *ngFor="let user of users" [value]="user.id">{{ user.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div fxLayoutGap="10px" fxLayoutAlign="space-between center">
    <mat-spinner diameter="30" *ngIf="_loading"></mat-spinner>
    <button mat-raised-button color="basic" (click)="notifyOperator()">
      Notificar Operador
      <mat-icon>forward_to_inbox
      </mat-icon>
    </button>
    <button mat-raised-button color="primary" (click)="save()">Salvar</button>
  </div>
</div>
